import ViewOnlyIcon from './ViewOnlyIcon'

export default ViewOnlyIcon
